import promiseFailSilently from './promise-fail-silently';

export default function promiseAllFailsafe(promises) {
  return Promise.all(
    promises.map((promise) => promiseFailSilently(() => promise)())
  );
}
